// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28-Iv","placeholdersHeader":"styles_placeholdersHeader__1f3hl","editorStyle":"styles_editorStyle__RoSwc","placeholdersBox":"styles_placeholdersBox__1VPxN"};